import React from 'react'

const renderHTML = (html: string) => {
  return React.createElement('span', {
    dangerouslySetInnerHTML: {__html: html},
  })
}

export default renderHTML
